import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'
import { useHomeStore } from '../store'
import { UZITI_VOZIDLA } from '../types'
import { CompanyAutocomplete } from './CompanyAutocomplete'
import { CoverageForm } from './CoverageForm'

export function ClientInfoCard() {
  const general = useHomeStore((s) => s.general)
  const setPojistnik = useHomeStore((s) => s.setPojistnik)
  const setVlastnik = useHomeStore((s) => s.setVlastnik)
  const setProvozovatel = useHomeStore((s) => s.setProvozovatel)
  const setOwnerSameAsPolicyholder = useHomeStore((s) => s.setOwnerSameAsPolicyholder)
  const setOperatorSameAsPolicyholder = useHomeStore((s) => s.setOperatorSameAsPolicyholder)
  const setGeneralField = useHomeStore((s) => s.setGeneralField)
  const setGlobalCoverage = useHomeStore((s) => s.setGlobalCoverage)

  return (
    <section className="overflow-hidden rounded-lg bg-white shadow-sm">
      <header className="bg-gradient-to-r from-purple-500 to-orange-400 px-6 py-4">
        <h2 className="text-base font-semibold text-white">Detaily pojištění</h2>
      </header>
      <div className="space-y-6 p-6">
        <h3 className="font-semibold text-zinc-900">Informace o klientovi</h3>
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="space-y-3">
            <div>
              <Label htmlFor="pojistnik-input">Pojistník</Label>
              <CompanyAutocomplete
                value={general.pojistnik}
                onChange={setPojistnik}
                placeholder="Zadejte IČO nebo název pojistníka"
                limit={10}
              />
            </div>
            <label className="flex items-center gap-2 text-xs text-zinc-700">
              <Checkbox checked={general.vat} onCheckedChange={(v) => setGeneralField('vat', !!v)} />
              <span>Pojistník je plátce DPH</span>
            </label>
            <div className="space-y-2">
              <label className="flex items-center gap-2 text-xs text-zinc-700">
                <Checkbox checked={general.ownerSameAsPolicyholder} onCheckedChange={(v) => setOwnerSameAsPolicyholder(!!v)} />
                <span>Vlastník je shodný s pojistníkem</span>
              </label>
              {!general.ownerSameAsPolicyholder && (
                <CompanyAutocomplete value={general.vlastnik} onChange={setVlastnik} placeholder="Zadejte IČO vlastníka" limit={5} />
              )}
            </div>
            <div className="space-y-2">
              <label className="flex items-center gap-2 text-xs text-zinc-700">
                <Checkbox checked={general.operatorSameAsPolicyholder} onCheckedChange={(v) => setOperatorSameAsPolicyholder(!!v)} />
                <span>Provozovatel je shodný s pojistníkem</span>
              </label>
              {!general.operatorSameAsPolicyholder && (
                <CompanyAutocomplete value={general.provozovatel} onChange={setProvozovatel} placeholder="Zadejte IČO provozovatele" limit={5} />
              )}
            </div>
          </div>

          <div className="space-y-3">
            <div>
              <Label htmlFor="start-date">Začátek pojištění</Label>
              <Input
                id="start-date"
                type="date"
                value={general.insurance_start_date}
                onChange={(e) => setGeneralField('insurance_start_date', e.target.value)}
              />
            </div>
            <div>
              <Label htmlFor="uziti">Užití vozidla</Label>
              <select
                id="uziti"
                value={general.uziti_vozidla}
                onChange={(e) => setGeneralField('uziti_vozidla', e.target.value)}
                className="block h-10 w-full appearance-none rounded-md border border-zinc-300 bg-white px-3 text-xs"
              >
                {UZITI_VOZIDLA.map((u) => (
                  <option key={u} value={u}>
                    {u}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div>
            <Label htmlFor="dalsi">Další informace</Label>
            <textarea
              id="dalsi"
              rows={5}
              value={general.dalsi_informace}
              onChange={(e) => setGeneralField('dalsi_informace', e.target.value)}
              className="w-full resize-none rounded-md border border-zinc-300 bg-white px-3 py-2 text-xs"
              placeholder="Zadejte další informace"
            />
          </div>
        </div>

        <div className="border-t-2 border-purple-400" />

        <div>
          <h3 className="mb-4 font-semibold text-purple-600">Pojistné krytí</h3>
          <CoverageForm value={general.pojistne_kryti} onChange={setGlobalCoverage} />
        </div>
      </div>
    </section>
  )
}
